import {useEffect, useState} from "react";
import {get} from "../../controlers/global/ConfigRequest";
import {
  GET_ALL_ORDERS,
  GET_ALL_ORDERS_UR,
  ORDERS_IN_PROCCESS,
  ORDERS_IN_PROCCESS_UR,
} from "../../helperData/ApiAddress";
import {ReactComponent as DidebanLogo} from "../../asset/icons/dideban_logo_blue.svg";
import {useTranslation} from "react-i18next";

// Exchange is in view-only mode: order registration is disabled and the
// remaining order book/history stays readable until final removal.
export default function Exchange({isUserPanel = false}) {

  const [ordersProccess, setOrdersProccess] = useState();
  const [loading, setLoading] = useState(false);
  const [buyOrders, setBuyOrders] = useState([]);
  const [sellOrders, setSellOrders] = useState([]);
  const {t} = useTranslation();

  const getAllOrders = () => {
    setLoading(true);
    const url = isUserPanel ? GET_ALL_ORDERS_UR : GET_ALL_ORDERS
    get(url)
      .then((r) => {
        const buyData = r.filter((item) => item.transaction_type === 1);
        setBuyOrders(buyData);
        const sellData = r.filter(
          (item) => item.transaction_type === 2
        );
        setSellOrders(sellData);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const fetchOrdersInProccess = () => {
    setLoading(true);
    const url = isUserPanel ? ORDERS_IN_PROCCESS_UR : ORDERS_IN_PROCCESS
    get(url).then((r) => {
      setOrdersProccess(r);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchOrdersInProccess();
    getAllOrders();
  }, []);

  if (loading) {
    return (
      <div className="dideban-loading">
        <DidebanLogo/>
      </div>
    );
  }

  return (
    <>
      <div className="alert alert-warning" role="status">
        {t("Organizational.PointsManagment.PointsExchange.Disabled.Notice")}
      </div>
      <div className="offer-tables page-load-fade">
        <div className="offer-table offer-sale">
          <div className="sale-header">
            {t("Organizational.PointsManagment.PointsExchange.PointsSellingOffer.Label")}
          </div>
          <div className="table-container">
            <table id="sell-table">
              <thead>
              <tr>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.Price.Label")}
                </th>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.Amount.Label")}
                </th>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.OverallAmount.Label")}
                </th>
              </tr>
              </thead>
              <tbody>
              {sellOrders.length > 0 ? (
                sellOrders
                  .sort(
                    (a, b) =>
                      a.price_of_each_coin -
                      b.price_of_each_coin
                  )
                  .map((item) => (
                    <tr>
                      <td>
                        {item.price_of_each_coin}{" "}
                        {t("Amount.Unit")}
                      </td>
                      <td>{item.number_of_coin}</td>
                      <td>
                        {item.price_of_each_coin *
                          item.number_of_coin}{" "}
                        {t("Amount.Unit")}
                      </td>
                    </tr>
                  ))
              ) : (
                <div>
                  {t("Organizational.PointsManagment.PointsExchange.NoDataToShow.Label")}
                </div>
              )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="offer-table offer-buy">
          <div className="buy-header">
            {t("Organizational.PointsManagment.PointsExchange.PointsBuyingOffer.Label")}
          </div>
          <div className="table-container">
            <table id="buy-table">
              <thead>
              <tr>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.Price.Label")}
                </th>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.Amount.Label")}
                </th>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.OverallAmount.Label")}
                </th>
              </tr>
              </thead>
              <tbody>
              {buyOrders.length > 0 ? (
                buyOrders
                  .sort(
                    (a, b) =>
                      b.price_of_each_coin -
                      a.price_of_each_coin
                  )
                  .map((item) => (
                    <tr>
                      <td>
                        {item.price_of_each_coin}{" "}
                        {t("Amount.Unit")}
                      </td>
                      <td>{item.number_of_coin}</td>
                      <td>
                        {item.price_of_each_coin *
                          item.number_of_coin}{" "}
                        {t("Amount.Unit")}
                      </td>
                    </tr>
                  ))
              ) : (
                <div>
                  {t("Organizational.PointsManagment.PointsExchange.NoDataToShow.Label")}
                </div>
              )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {ordersProccess?.length > 0 &&
        (loading ? (
          <div>Loading...</div>
        ) : (
          <div className={"table-container"}>
            <table className="user-table exchange-table-con">
              <thead>
              <tr className="header-row">
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.Row.Label")}
                </th>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.FunctionType.Label")}
                </th>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.PointsAmount.Label")}
                </th>
                <th>
                  {t("Organizational.PointsManagment.PointsExchange.Price.Label")}
                </th>
              </tr>
              </thead>
              <tbody>
              {ordersProccess ? (
                ordersProccess.map((item, index) => (
                  <tr className="user-table-row" key={item.id}>
                    <td className="index-title">
                      <div className="level">
                        {index + 1}
                      </div>
                    </td>

                    <td className="user">
                      <div>
                        <div>
                          {item.transaction_type ===
                          1
                            ? t(
                              "Src.pages.Rating.Exchange.Buy.Title"
                            )
                            : t(
                              "Src.pages.Rating.Exchange.Sell.Title"
                            )}
                        </div>
                      </div>
                    </td>
                    <td>{item.number_of_coin}</td>
                    <td>
                      {item.price_of_each_coin}
                    </td>
                  </tr>
                ))
              ) : (
                <div>
                  {t("Src.pages.Rating.Exchange.Not.Found")}
                </div>
              )}
              </tbody>
            </table>
          </div>
        ))}
    </>
  );
}
